<template>
    <div id="pdfvuer" class="color-dark">
        <!-- <div id="buttons" class="ui grey three item inverted bottom fixed menu transition" style="background: red">
            <a class="item" @click="onPrevPage">
                <i class="left chevron icon"></i>
                Back
            </a>
            <a class="ui active item">
                {{page}} / {{ numPages ? numPages : '∞' }}
            </a>
            
            <a class="item" @click="onNextPage">
                Forward
                <i class="right chevron icon"></i>
            </a>
        </div> -->
        <!-- <div id="buttons" class="ui grey three item inverted bottom fixed menu transition position-center-x"> -->
            <!-- <a class="item" @click="scale -= scale > 0.2 ? 0.1 : 0">
                <i class="left chevron icon" />
                Zoom -
            </a>
            <a class="ui active item">
                {{ formattedZoom }} %
            </a>
            <a class="item" @click="scale += scale < 2 ? 0.1 : 0">
                Zoom +
                <i class="right chevron icon" />
            </a> -->
            <!-- <input class="opacity-0" ref="ipaction" v-on:keyup.left="onPrevPage" v-on:keyup.right="onNextPage"> -->
        <!-- </div> -->
        <swiper :options="swiperOption" ref="slidePptx" class="side-docs">
	        <swiper-slide v-for="(i, index) in pagesDocShow" :key="i">
	        	<pdf :src="`${appUrl}${pathView}`" :text="false" :key="i" :id="i" :page="i" :scale.sync="zoomData" style="width:100%" >
		            <template slot="loading" class="text-center">
		                <b-spinner small type="grow" variant="dark" />
		            </template>
		        </pdf>
	        </swiper-slide>
	        <div class="swiper-button-prev" slot="button-prev"></div>
	        <div class="swiper-button-next" slot="button-next"></div>
	    </swiper>
        <div class="file-err text-center color-dark font-size-20" v-if="isNotFile">
			Tệp hiện tại không tồn tại
		</div>
    </div>
</template>

<script>
    import pdfvuer from 'pdfvuer'
    import { APP_CONFIG } from '@/utils/constants'
    import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'Previewpptx',
        components: {
            pdf: pdfvuer,
            swiper,
    		swiperSlide
        },
        props: {
            pathView: String,
            zoomData: Number
        },
        data () {
            return {
            	appUrl: APP_CONFIG.appUrl,
                page: 1,
                numPages: 0,
                errors: [],
                scale: 'page-width',
                swiperOption: this.settingSwiper(),
                isNotFile: false,
                eachPage: 4,
                pagesDocShow: 0
            }
        },
        computed: {
            // formattedZoom () {
            //     return Number.parseInt(this.scale * 100);
            // },
            swiper() {
        		return this.$refs.slidePptx.swiper
      		}
        },
        created() {
            window.addEventListener('keyup', this.onKeyup)
        },
        mounted () {
            this.getPdf()
        },
        watch: {
            // show: function (s) {
            //     if(s) {
            //         this.getPdf();
            //     }
            // },
            // page: function (p) {
            //     if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
            //         // window.scrollTo(0,this.findPos(document.getElementById(p)));
            //         document.getElementById(p).scrollIntoView();
            //     }
            // }
        },
        destroyed () {
            window.removeEventListener('keyup', this.onKeyup)
        },
        methods: {
            getPdf () {
                let self = this;
                let pdfdata = pdfvuer.createLoadingTask(`${APP_CONFIG.bookCdnUrl}${self.pathView}`);
                pdfdata.then(pdf => {
                    self.numPages = pdf.numPages;
                    self.pagesDocShow = pdf.numPages > self.eachPage ? self.eachPage : pdf.numPages;
                }).catch(() => {self.isNotFile = true});
            },
            findPos(obj) {
                return obj.offsetTop;
            },

            settingSwiper() {
				let self = this;
				return {
		          	slidesPerView: 1,
		          	spaceBetween: 0,
		          	// lazy: true,
		          	// hashNavigation: {
		           //  	watchState: true,
		          	// },
		          	navigation: {
		            	nextEl: '.swiper-button-next',
		            	prevEl: '.swiper-button-prev',
		          	},
		          	// effect: 'flip',
		          	on: {
						slideChange: function () {
							self.page = this.realIndex + 1;
							self.lazyLoadPages();
						}
					}
		        }
			},

            onPrevPage() {
            	this.page = this.page > 1 ? this.page - 1 : 1;
            	this.swiper.slideTo(this.page - 1, 1000, false)
            	this.lazyLoadPages();
            },

            onNextPage() {
            	this.page = this.page < this.numPages ? this.page + 1 : this.numPages;
            	this.swiper.slideTo(this.page - 1, 1000, false)
            	this.lazyLoadPages();
            },

            onKeyup(e) {
                e.keyCode === 37 && this.onPrevPage()
                e.keyCode === 39 && this.onNextPage()
            },

            lazyLoadPages() {
            	let self = this;
            	if(self.page === (self.pagesDocShow - 2) && self.pagesDocShow < self.numPages) {
                    if( Number(self.pagesDocShow + self.eachPage) > self.numPages ) {
                        self.pagesDocShow = self.numPages;
                    } else {
                        self.pagesDocShow += self.eachPage;
                    }
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    #buttons {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    /* Page content */
    .content {
        padding: 16px;
    }
    .file-err {
		padding: 50px 15px;
	}
</style>